export enum ContentTypeFilterValues {
  MEDIUM = 'medium',
  LARGE = 'large',
  ULTRA = 'ultra',
  RAW = 'raw',
}
